// Step Types
import Basic from '../components/Steps/Basic';
import Price from '../components/Steps/Price';
import ProductPrice from '../components/Steps/ProductPrice';
import Login from '../components/Steps/Login';
import { Confirmation } from '../components/Steps/Confirmation';

// Step Components
import Accordion from '../components/Steps/General/Accordion';
import AccordionAdvanced from '../components/Steps/General/AccordionAdvanced';
import AutoSuggest from '../components/Steps/Input/AutoSuggest';
import Button from '../components/Steps/General/Button';
import Condition from '../components/Steps/General/Condition';
import ColumnLayout from '../components/Steps/General/ColumnLayout';
import ComponentGroup from '../components/Steps/General/ComponentGroup';
import Hero from '../components/Steps/General/Hero';
import InfoBox from '../components/Steps/General/InfoBox';
import ProductBox from '../components/Steps/General/ProductBox';
import ProductSelector from '../components/Steps/General/ProductSelector';
import InputGroup from '../components/Steps/Input/InputGroup';
import InputSelect from '../components/Steps/Input/Select';
import InputText from '../components/Steps/Input/Text';
import CprText from '../components/Steps/Input/CprText';
import Address from '../components/Steps/Input/AutoSuggest/Address';
import CvrText from '../components/Steps/Input/CvrText';
import TextArea from '../components/Steps/Input/TextArea';
import Slider from '../components/Steps/General/Slider';
import Carousel from '../components/Steps/General/Carousel';
import Space from '../components/Steps/General/Space';
import TextText from '../components/Steps/General/TextBlock';
import Divider from '../components/Steps/General/Divider';
import Ajax from '../components/Steps/General/Ajax';
import { Notification } from '../components/Steps/General/Notification';
import Link from '../components/Steps/General/Link';
import Coverage from '../components/Steps/General/Coverage';
import Title from '../components/Steps/General/Title';
import ProductSummary from '../components/Steps/General/ProductSummary';
import ProductConfirmation from '../components/Steps/General/ProductConfirmation';
import ProductCard from '../components/Steps/General/ProductCard';
import TextSimple from '../components/Global/Text';
import BackButton from '../components/Global/BackButton';
import Recommendation from '../components/Steps/General/Recommendation';
import RecommendationContact from '../components/Steps/General/RecommendationContact';
import GraphicLoader from '../components/Steps/General/GraphicLoader';
import TextLoader from '../components/Steps/General/TextLoader';
import ActionText from '../components/Steps/General/ActionText';
import TrustPilotWidget from '../components/Steps/General/Trustpilot';
import IdleAction from '../components/Steps/General/IdleAction';
import OptionalCoverages from '../components/Steps/General/OptionalCoverages';
import Label from '../components/Form/Label';
import Icon from '../components/Global/Icon';
import DatePicker from '../components/Steps/Input/DatePicker';
import Consent from '../components/Steps/General/Consent';
import CoverageOverview from '../components/Steps/General/CoverageOverview';
import TelephoneInput from '../components/Steps/Input/TelephoneInput';
import { Multiproduct } from '../components/InsuranceSelector/MultiProductSelector';
import { CombinedAccordion } from '../components/Steps/General/CombinedAccordion';
import { CombinedAccordionNew } from '../components/Steps/General/CombinedAccordionNew';
import { CompactPackage } from '../components/CoverageCompact/CoverageCompact';
import { CompactPrce } from '../components/Steps/Price/CompactPrice';
import { CombinedSummaryDetails } from '../components/Steps/General/CombinedSummaryDetails';
import { CombinedTaxLabel } from '../components/Steps/General/CombinedTaxLabel';
import { CombinedSummaryError } from '../components/Steps/General/CombinedSummaryError';
import NavigationContainer from '../components/Global/NavigationContainer';
import AnchorInputText from '../components/Steps/Input/AnchorInputText';
import { VideoSection } from '../components/Steps/General/VideoSection';
import { InfoSection } from '../components/Steps/General/InfoSection';
import AnchorCheckbox from '../components/Steps/Input/AnchorCheckbox';
import { PriceCalculator } from '../components/Steps/Price/PriceCalculator';
import TerminateInsurance from '../components/Steps/General/TerminateInsurance';
import DynamicConfirmationSection from '../components/Steps/General/DynamicConfirmationSection';
import MitIdButton from '../components/Steps/General/MitIdButton';
import { AnchorSpinner } from '../components/Global/AnchorSpinner';
import AnchorCheckboxList from '../components/Steps/Input/AnchorCheckboxList';

// Step Types
export const stepTypes = {
  Basic,
  Price,
  ProductPrice,
  Login,
  Confirmation
};

// Step Components
export const stepComponents = {
  // General
  'multiProductSelector': Multiproduct,
  'accordion': Accordion,
  'accordionAdvanced': AccordionAdvanced,
  'combinedAccordion': CombinedAccordion,
  'combinedAccordionNew': CombinedAccordionNew,
  'coverageOverview': CoverageOverview,
  'button': Button,
  'navigationContainer': NavigationContainer,
  'condition': Condition,
  'columnLayout': ColumnLayout,
  'componentGroup': ComponentGroup,
  'hero': Hero,
  'infoBox': InfoBox,
  'productBox': ProductBox,
  'productSelector': ProductSelector,
  'slider': Slider,
  'carousel': Carousel,
  'link': Link,
  'coverage': Coverage,
  'productSummary': ProductSummary,
  'productConfirmation': ProductConfirmation,
  'productCard': ProductCard,
  'recommendation': Recommendation,
  'recommendationContact': RecommendationContact,
  'graphicLoader': GraphicLoader,
  'textLoader': TextLoader,
  'idleAction': IdleAction,
  'label': Label,
  'icon': Icon,
  'consent': Consent,
  'compactPackage': CompactPackage,
  'compactPrice': CompactPrce,
  'priceCalculator': PriceCalculator,
  'terminateInsurance': TerminateInsurance,
  'combinedSummaryDetails': CombinedSummaryDetails,
  'combinedTaxLabel': CombinedTaxLabel,
  'combinedSummaryError': CombinedSummaryError,
  'videoSection': VideoSection,
  'infoSection': InfoSection,
  'dynamicConfirmationSection': DynamicConfirmationSection,
  'anchorSpinner': AnchorSpinner,
  // Group
  'checkbox': InputGroup,
  'checkboxButtons': InputGroup,
  'radio': InputGroup,
  'radioButtons': InputGroup,
  'select': InputSelect,
  'toggleSwitch': InputGroup,
  // Input
  'autoSuggest': AutoSuggest,
  'text': InputText,
  'email': InputText,
  'number': InputText,
  'password': InputText,
  'tel': InputText,
  'space': Space,
  'divider': Divider,
  'cprText': CprText,
  'address': Address,
  'cvrText': CvrText,
  'textarea': TextArea,
  'datePicker': DatePicker,
  'phoneInput': TelephoneInput,
  'anchorText': AnchorInputText,
  'anchorCheckbox': AnchorCheckbox,
  'anchorCheckboxList': AnchorCheckboxList,
  // Text
  'textBlock': TextText,
  'textHeader': TextText,
  'title': Title,
  'textSimple': TextSimple,
  // Ajax
  'ajax': Ajax,
  'notification': Notification,
  'backButton': BackButton,
  'actionText': ActionText,
  'trustPilotWidget': TrustPilotWidget,
  'optionalCoverages': OptionalCoverages,
  'MitIdButton': MitIdButton
};